import { urlSanitizer } from '@bcf-vanilla-ui-ts-v1/shared/sanitation/url-sanitizer';
import type { ChangedLangDetectorService } from '@bcf2-v1-ui-shared/services/changed-lang-detector.service';
import { provideChangedLangDetectorService } from '@bcf2-v1-ui-shared/services/changed-lang-detector.service';
import { RouteThemeData, ThemeVariant } from '@bcfds-design-system/shared/types';
import { provideSvgIconAppComputedStylesService } from '@bcflit-ds-components/base/svg-icon/svg-icon-app-computed-styles.service';
import { provideAppDestroyController } from '@bcflit-v1-ui-shared/app-destroy/app-destroy.controller';
import { UnsubscribableBcfLitElement } from '@bcflit-v1-ui-shared/classes/unsubscribable-bcf-lit-element';
import { ActivatedRoute, provideActivatedRoute } from '@tmf-shared-platform/activated-route/activated-route';
import { HistoryUrl, provideHistoryUrl } from '@tmf-shared-platform/history-url/history-url';
import { BcfLitRouter } from '@tmf-shared-platform/router/internal';
import {
  provideRouterNavigatorService,
  RouterNavigatorService
} from '@tmf-shared-platform/router/router-navigator.service';
import { routerPageScrollerService } from '@tmf-shared-platform/router/router-page-scroller.service';
import { render } from 'lit';
import { property } from 'lit/decorators.js';

export class BcflitBaseAppWithInstrumentations extends UnsubscribableBcfLitElement {
  public router: BcfLitRouter | undefined;

  constructor(
    protected _activatedRoute: ActivatedRoute = provideActivatedRoute(),
    private _historyUrl: HistoryUrl = provideHistoryUrl(),
    private _changedLangDetectorService: ChangedLangDetectorService = provideChangedLangDetectorService()
  ) {
    super();
  }

  @property({ type: String, reflect: true })
  public theme: ThemeVariant | undefined;

  public override connectedCallback(): void {
    super.connectedCallback();
    provideAppDestroyController(this).init();
    if (Reflect.has(render, 'setSanitizer')) {
      render.setSanitizer(urlSanitizer);
    }
    this._changedLangDetectorService.init();

    const csrUrl: string = window.location.pathname;
    if (!csrUrl.endsWith('/')) {
      window.location.href = `${csrUrl}/${window.location.search}`;
      return;
    }

    const routerNavigatorService: RouterNavigatorService = provideRouterNavigatorService();
    routerNavigatorService.bindRouter(this.router!);
    routerNavigatorService.bindHistoryUrl(this._historyUrl);
    routerPageScrollerService.init();
    this._activatedRoute.addRouter(this.router!);
    provideSvgIconAppComputedStylesService().setComputedStyles(() => getComputedStyle(this));
    document.querySelector('.splash-screen')?.remove();

    this._sub = this._activatedRoute.data$.subscribe((data: Partial<RouteThemeData>) => {
      if (data.theme) {
        this.theme = data.theme;
      } else {
        this.theme = undefined;
      }
    });
  }
}
